import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/images/vk_cl_line.png'
import _imports_1 from '@/assets/images/fx_icon.png'
import _imports_2 from '@/assets/images/vk_dy_line.png'


const _hoisted_1 = { class: "thirdScene-container" }
const _hoisted_2 = { class: "setting-container" }
const _hoisted_3 = {
  key: 0,
  class: "setting-content"
}
const _hoisted_4 = {
  key: 0,
  class: "environInfo-container"
}
const _hoisted_5 = { class: "item-box" }
const _hoisted_6 = { class: "info-box" }
const _hoisted_7 = { class: "item-box" }
const _hoisted_8 = { class: "icon-box" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "info-box" }
const _hoisted_11 = { class: "unit" }
const _hoisted_12 = { class: "item-box setting-box" }
const _hoisted_13 = { class: "model-body" }
const _hoisted_14 = { class: "wind-direction" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "wind-direction wind-level" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "model-footer" }
const _hoisted_20 = {
  class: "standard-setting-body",
  "element-loading-background": "rgba(21, 24, 29, 0.8)"
}
const _hoisted_21 = { class: "standard-item-left" }
const _hoisted_22 = { class: "title-text" }
const _hoisted_23 = { class: "progress-container" }
const _hoisted_24 = { class: "standard-item-right" }
const _hoisted_25 = { class: "model-footer" }

import {ref,reactive,onMounted,onBeforeUnmount,onBeforeMount, computed,getCurrentInstance,watch} from 'vue'
import {useStore} from 'vuex'
import {useRouter, useRoute} from 'vue-router'
import { createTraining, getSceneInfoTabList, getScoringItemSetting, saveScoringItemSetting, saveUserTrainingSetting } from '@/service'
import {$enum, $config} from '@/global/index'
import {StationItem,ICard} from '@/types/baseInterFace'

const SCORING_ERROR_MESSAGE_DURATION = 2000
type ScoringValueKey = 'heightOffset' | 'positionOffset' | 'headingOffset'
type ScoringMinKey = 'minHeightOffset' | 'minPositionOffset' | 'minHeadingOffset'
type ScoringMaxKey = 'maxHeightOffset' | 'maxPositionOffset' | 'maxHeadingOffset'

interface ScoringSetting {
  sceneTypeId: string
  heightOffset: number
  positionOffset: number
  headingOffset: number
  defaultHeightOffset: number
  defaultPositionOffset: number
  defaultHeadingOffset: number
  minHeightOffset: number
  maxHeightOffset: number
  minPositionOffset: number
  maxPositionOffset: number
  minHeadingOffset: number
  maxHeadingOffset: number
}

interface ScoringSettingItem {
  key: ScoringValueKey
  minKey: ScoringMinKey
  maxKey: ScoringMaxKey
  defaultKey: 'defaultHeightOffset' | 'defaultPositionOffset' | 'defaultHeadingOffset'
  label: string
  unit: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const proxy = getCurrentInstance()?.proxy
const cardsList = ref<ICard[]>([])
const store = useStore()
const router = useRouter()
const route = useRoute()
const requireImg = (name: string)=>{
  return require(`@/assets/images/${name}.png`)
}
const windDirectiones = ref(['北风','东北风','东风','东南风','南风','西南风','西风','西北风','随机风'])
const windSpeedList = ref([{value:'0~0.2',label:'无',icon:requireImg('fs_wu')},{value:'0.3~1.5',label:'1级',icon:requireImg('fs_yiji')},{value:'1.6~3.3',label:'2级',icon:requireImg('fs_erji')},{value:'3.4~5.4',label:'3级',icon:requireImg('fs_sanji')},{value:'5.5~7.9',label:'4级',icon:requireImg('fs_siji')},{value:'8.0~10.7',label:'5级',icon:requireImg('fs_wuji')}])
const windIndex = ref(-1)
const speedIndex = ref(-1)
const confirmLoading = ref(false)
//显示标准设置
const showStandardSetting = ref(false)
const standardSettingLoading = ref(false)
const scoringConfirmLoading = ref(false)
let scoringErrorMessageVisible = false
let scoringErrorMessageTimer: ReturnType<typeof setTimeout> | null = null
let isThirdSceneUnmounted = false

const scoringSetting = reactive<ScoringSetting>({
  sceneTypeId: '',
  heightOffset: 0.5,
  positionOffset: 0.5,
  headingOffset: 25,
  defaultHeightOffset: 0.5,
  defaultPositionOffset: 0.5,
  defaultHeadingOffset: 25,
  minHeightOffset: 0.5,
  maxHeightOffset: 5,
  minPositionOffset: 0.5,
  maxPositionOffset: 5,
  minHeadingOffset: 25,
  maxHeadingOffset: 60,
})

const scoringSettingItems: ScoringSettingItem[] = [
  { key: 'heightOffset', minKey: 'minHeightOffset', maxKey: 'maxHeightOffset', defaultKey: 'defaultHeightOffset', label: '高度偏差', unit: 'm' },
  { key: 'positionOffset', minKey: 'minPositionOffset', maxKey: 'maxPositionOffset', defaultKey: 'defaultPositionOffset', label: '位置偏差', unit: 'm' },
  { key: 'headingOffset', minKey: 'minHeadingOffset', maxKey: 'maxHeadingOffset', defaultKey: 'defaultHeadingOffset', label: '航向夹角', unit: '°' },
]

const currentCardItem = ref<ICard>()
const sceneTypeId = ref(store.state.persistence.breadcrumb[store.state.persistence.breadcrumb.length-2].id)
const currentStationId = ref(store.state.persistence.userTrainSettingInfo.currentStationId || null)
const courseTypeId = ref(store.state.persistence.breadcrumb[store.state.persistence.breadcrumb.length-2].courseTypeId)
const showModel = ref(false)
const isShowMode = ref(false)

const useStandardSetting = computed(()=>{
  return isTrain.value && store.state.persistence.breadcrumb[1].courseTypeId == 1
})
const selectedCardId = computed(() => store.state.persistence.carouselSelection?.thirdSceneCardId ?? null)
const currentWindDirection = computed(()=>{
  if(store.state.persistence.userTrainSettingInfo.windDirection){
    return windDirectiones.value.findIndex(item=> item == store.state.persistence.userTrainSettingInfo.windDirection)
  }else{
    return 0
  }
  
})
const currentWindSpeed = computed(()=>{
  if(store.state.persistence.userTrainSettingInfo.windPower){
    return store.state.persistence.userTrainSettingInfo.windPower
  }else{
    return 0
  }
})

const isTrain = computed(()=>{
  if(Array.isArray(store.state.persistence.breadcrumb) && store.state.persistence.breadcrumb.length == 3){
    return store.state.persistence.breadcrumb[2].id == 2
  }
  return false
})


async function getPageData(){
  cardsList.value = []
  let param = {
    "userId": store.state.persistence.userInfo.userId,
    "tenantId": store.state.persistence.currentTenantId,
    "sceneCategoryId":store.state.persistence.breadcrumb[store.state.persistence.breadcrumb.length-1].id,
    "sceneTypeId": sceneTypeId.value
  }
  isShowMode.value = false
  const {code, data, message} = await getSceneInfoTabList(param);
  if(code == $enum.EnumResult.SUCCESS){
    if(Array.isArray(data) && data.length){
      let arr = []
      data.forEach((item, index) => {
        if(item.courseTypeId == $enum.CourseTypeEnum.电力巡检 && item.sceneCategoryId == $enum.SceneCategoryEnum.通关测试 && !isShowMode.value){
          isShowMode.value = true
        }
        arr.push({
          ...item,
          id: item.id,
          title: item?.sceneSubTypeName,
          description: item.typeDescription,
          userAvailable: item.isLocked,
          pictureUrl: $config.FILE_ROOT_PATH + item.pictureUrl,
          sortIndex: index + 1 < 10? '0' + (index + 1) : index + 1,
          isLocked: item.isLocked
        })
      });
      cardsList.value = arr
    }
  }
}

// 进入飞行页面
async function enterFlightPage(cardItem:ICard | undefined){
  if(!cardItem) return
  let airLineId = null
  let sceneImageUrl = null
  let nestId = null
  let resourceFileList = []
  let stationId = null
  if(courseTypeId.value == $enum.CourseTypeEnum.CAAC多旋翼){
    //caac
    let currentStatsionData = cardItem?.stationList?.find(item => item.stationId == currentStationId.value) || {}
    airLineId = currentStatsionData?.airLineId
    sceneImageUrl = currentStatsionData?.scenePictureUrl
    nestId = currentStatsionData?.uavNestId
    resourceFileList = currentStatsionData?.resourceFileList
    stationId = currentStatsionData?.stationId
  }
  if(courseTypeId.value == $enum.CourseTypeEnum.电力巡检){
    //输电模式
    airLineId = cardItem?.stationList[0]?.airLineId
    sceneImageUrl = cardItem?.stationList[0]?.scenePictureUrl
    nestId = cardItem?.stationList[0]?.uavNestId
    resourceFileList = cardItem?.stationList[0]?.resourceFileList
    stationId = cardItem?.stationList[0]?.stationId
  }
  let windPower = null
  if((cardItem.courseTypeId == $enum.CourseTypeEnum.CAAC多旋翼 && isTrain.value) || (cardItem.courseTypeId == $enum.CourseTypeEnum.电力巡检 && cardItem.sceneCategoryId == $enum.SceneCategoryEnum.科目训练)){
    //caac训练和输电训练模式创建训练数据加风速
    windPower = currentWindSpeed.value
  }
  let param = {
    userId:store.state.persistence.userInfo.userId,
    sceneId:cardItem.id,
    uavSpecificationId:store.state.persistence.currentUavInfo.uavId,
    airLineId:airLineId,
    difficultyType:cardItem?.difficultyType,
    windPower,
    windDirection:windDirectiones.value[currentWindDirection.value],
    stationId
  }
  const {code, data} = await createTraining(param);
  if(code == $enum.EnumResult.SUCCESS){
    const {trainingId} = data as any || {};
    store.commit('persistence/setCurrentUavInfo', {
      ...store.state.persistence.currentUavInfo,
      nestId,
      trainingId,
      heightLimit:cardItem?.heightLimit,
      parentName:isTrain.value?'训练':'通关',
      sceneImageUrl,
      sceneInfo:cardItem,
      resourceFileList,
      windSpeedIndex:windSpeedList.value[currentWindSpeed.value].value.replace("~",","),
      windDirectionIndex:currentWindDirection.value,
    });
    store.commit("persistence/setStationId", stationId);
    if(cardItem.courseTypeId == 1){
      if(isTrain.value){
        router.push('/flight/train')
      }else{
        router.push('/flight/passTest')
      }
    }else{
      router.push('/flight/transmit')
    }
  }else{
    proxy?.vknMessage.error('创建新训练失败！')
  }
}


function handleClick(cardItem:ICard){
  if(cardItem.isLocked) return
  store.commit('persistence/setCarouselSelection', {
    ...store.state.persistence.carouselSelection,
    thirdSceneCardId: cardItem.id
  })
  enterFlightPage(cardItem)
}

function handleSetting(){
  window?.playClick()
  speedIndex.value = currentWindSpeed.value
  windIndex.value = currentWindDirection.value
  showModel.value = true;
}

function applyScoringSetting(data: ScoringSetting): boolean {
  if (!data) return false

  const numberKeys: Array<Exclude<keyof ScoringSetting, 'sceneTypeId'>> = [
    'heightOffset', 'positionOffset', 'headingOffset',
    'defaultHeightOffset', 'defaultPositionOffset', 'defaultHeadingOffset',
    'minHeightOffset', 'maxHeightOffset',
    'minPositionOffset', 'maxPositionOffset',
    'minHeadingOffset', 'maxHeadingOffset',
  ]
  if (numberKeys.some(key => !Number.isFinite(Number(data[key])))) return false

  scoringSetting.sceneTypeId = String(data.sceneTypeId)
  numberKeys.forEach(key => {
    scoringSetting[key] = Number(data[key])
  })
  return true
}

function isValidScoringSetting(): boolean {
  return scoringSettingItems.every(item => {
    const value = scoringSetting[item.key]
    return Number.isFinite(value)
      && value >= scoringSetting[item.minKey]
      && value <= scoringSetting[item.maxKey]
      && Math.abs(value * 100 - Math.round(value * 100)) < 0.000001
  })
}

function resetScoringErrorMessage() {
  scoringErrorMessageVisible = false
  if (scoringErrorMessageTimer) {
    clearTimeout(scoringErrorMessageTimer)
    scoringErrorMessageTimer = null
  }
}

function showScoringErrorMessage(message: string) {
  if (isThirdSceneUnmounted || scoringErrorMessageVisible) return

  scoringErrorMessageVisible = true
  proxy?.vknMessage.error({
    message,
    duration: SCORING_ERROR_MESSAGE_DURATION,
    onClose: resetScoringErrorMessage,
  })
  scoringErrorMessageTimer = setTimeout(
    resetScoringErrorMessage,
    SCORING_ERROR_MESSAGE_DURATION + 300,
  )
}

function getEmptyScoringSettingItem() {
  return scoringSettingItems.find(item => {
    const value = scoringSetting[item.key] as unknown
    return value === null || value === undefined || value === ''
  })
}

function buildScoringSettingRequest() {
  const currentSceneTypeId = String(sceneTypeId.value ?? '')
  if (!currentSceneTypeId) return null

  const values = scoringSettingItems.reduce<Record<ScoringValueKey, number>>((result, item) => {
    result[item.key] = scoringSetting[item.key]
    return result
  }, {} as Record<ScoringValueKey, number>)

  if (Object.values(values).some(value => !Number.isFinite(value))) return null
  return {
    sceneTypeId: currentSceneTypeId,
    ...values,
  }
}

async function handleOpenStandardSetting() {
  if (standardSettingLoading.value) return
  window?.playClick()
  const currentSceneTypeId = String(sceneTypeId.value ?? '')
  if (!currentSceneTypeId) {
    proxy?.vknMessage.error('暂无可用的科目训练场景')
    return
  }
  showStandardSetting.value = true
  standardSettingLoading.value = true
  try {
    const { code, data, message } = await getScoringItemSetting({ sceneTypeId: currentSceneTypeId })
    if (isThirdSceneUnmounted) return
    if (code !== $enum.EnumResult.SUCCESS || !applyScoringSetting(data)) {
      proxy?.vknMessage.error(message || '合格判定参数加载失败')
      showStandardSetting.value = false
      return
    }
  } catch (error) {
    if (!isThirdSceneUnmounted) {
      proxy?.vknMessage.error('合格判定参数加载失败')
    }
    showStandardSetting.value = false
  } finally {
    standardSettingLoading.value = false
  }
}

function handleCloseStandardSetting() {
  if (scoringConfirmLoading.value) return
  window?.playClick()
  showStandardSetting.value = false
}

async function saveCurrentScoringSetting() {
  const emptyItem = getEmptyScoringSettingItem()
  if (emptyItem) {
    showScoringErrorMessage(`请输入${emptyItem.label}`)
    return false
  }

  const request = buildScoringSettingRequest()
  if (!request || !isValidScoringSetting()) {
    showScoringErrorMessage('请检查合格判定参数')
    return false
  }

  const { code, data, message } = await saveScoringItemSetting(request)
  if (isThirdSceneUnmounted) return false
  if (code !== $enum.EnumResult.SUCCESS || !applyScoringSetting(data)) {
    proxy?.vknMessage.error(message || '保存失败')
    return false
  }
  return true
}

function handleRestoreScoringSetting() {
  if (standardSettingLoading.value || scoringConfirmLoading.value) return
  window?.playClick()
  scoringSettingItems.forEach(item => {
    scoringSetting[item.key] = scoringSetting[item.defaultKey]
  })
}

async function handleSaveScoringSetting() {
  if (scoringConfirmLoading.value) return
  window?.playClick()
  scoringConfirmLoading.value = true
  try {
    if (await saveCurrentScoringSetting()) {
      if (isThirdSceneUnmounted) return
      proxy?.vknMessage.success('保存成功')
      showStandardSetting.value = false
    }
  } catch (error) {
    if (!isThirdSceneUnmounted) {
      proxy?.vknMessage.error('保存失败')
    }
  } finally {
    scoringConfirmLoading.value = false
  }
}

function handleSwitch(type:string,index:number){
  window?.playClick()
  if(type == 'direction'){
    windIndex.value = index
  }else{
    speedIndex.value = index
  }
}


async function handleConfirm(){
  let param = {
    "userId": store.state.persistence.userInfo.userId,
    "tenantId": store.state.persistence.currentTenantId,
    "sceneTypeId": sceneTypeId.value,
    "windDirection": windDirectiones.value[windIndex.value],
    "windPower": speedIndex.value
  }
  confirmLoading.value = true
  window?.playClick()
  let {code , data, message} = await saveUserTrainingSetting(param)
  confirmLoading.value = false
  if(code !== $enum.EnumResult.SUCCESS || !data){
    proxy?.vknMessage.error(message || '保存失败')
    return;
  }
  store.commit('persistence/setUserTrainingSetting', {
    ...store.state.persistence.userTrainSettingInfo,
    windDirection: windDirectiones.value[windIndex.value],
    windPower: speedIndex.value
  });
  showModel.value = false;
}

function handleClose(){
  window?.playClick()
  showModel.value = false;
}

onBeforeMount(()=>{
  getPageData();
})

onBeforeUnmount(() => {
  isThirdSceneUnmounted = true
  resetScoringErrorMessage()
  proxy?.vknMessage.close()
})


return (_ctx: any,_cache: any) => {
  const _component_vkm_carousel = _resolveComponent("vkm-carousel")!
  const _component_vkn_button = _resolveComponent("vkn-button")!
  const _component_vkm_modal = _resolveComponent("vkm-modal")!
  const _component_el_slider = _resolveComponent("el-slider")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_vkm_carousel, {
      cardsList: cardsList.value,
      useControls: true,
      onOnClick: handleClick,
      isShowMode: isShowMode.value,
      isShowSort: true,
      isShowLock: true,
      supportSelect: true,
      selectedCardId: selectedCardId.value
    }, null, 8, ["cardsList", "isShowMode", "selectedCardId"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "standard-setting-container",
        style: _normalizeStyle({background:!useStandardSetting.value?'transparent':'rgba(255, 255, 255, 0.05)'})
      }, [
        (useStandardSetting.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_vkn_button, {
                label: "标准设置",
                type: "info",
                "icon-placement": "left",
                size: "medium",
                onClick: handleOpenStandardSetting
              }, {
                icon: _withCtx(() => _cache[0] || (_cache[0] = [
                  _createElementVNode("img", {
                    src: _imports_0,
                    alt: ""
                  }, null, -1)
                ])),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ], 4),
      (isTrain.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "icon-box" }, [
                _createElementVNode("img", {
                  src: _imports_1,
                  alt: ""
                })
              ], -1)),
              _createElementVNode("div", _hoisted_6, [
                _cache[1] || (_cache[1] = _createElementVNode("span", { class: "title" }, "风向", -1)),
                _createElementVNode("p", null, _toDisplayString(windDirectiones.value[currentWindDirection.value]), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("img", {
                  src: windSpeedList.value[currentWindSpeed.value]?windSpeedList.value[currentWindSpeed.value]?.icon:windSpeedList.value[0]?.icon,
                  alt: ""
                }, null, 8, _hoisted_9)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _cache[3] || (_cache[3] = _createElementVNode("span", { class: "title" }, "风速", -1)),
                _createElementVNode("p", null, [
                  _createTextVNode(_toDisplayString(windSpeedList.value[currentWindSpeed.value]?.label) + " ", 1),
                  _createElementVNode("span", _hoisted_11, _toDisplayString(windSpeedList.value[currentWindSpeed.value]?.value?`${windSpeedList.value[currentWindSpeed.value]?.value}m/s`:''), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_vkn_button, {
                label: "环境设置",
                type: "info",
                "icon-placement": "left",
                size: "medium",
                onClick: handleSetting
              }, {
                icon: _withCtx(() => _cache[4] || (_cache[4] = [
                  _createElementVNode("img", {
                    src: _imports_2,
                    alt: ""
                  }, null, -1)
                ])),
                _: 1
              })
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (showModel.value)
      ? (_openBlock(), _createBlock(_component_vkm_modal, {
          key: 0,
          title: "环境设置",
          onOnClose: handleClose
        }, {
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_13, [
              _cache[5] || (_cache[5] = _createElementVNode("p", { class: "option-title" }, "风向", -1)),
              _createElementVNode("ul", _hoisted_14, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(windDirectiones.value, (windItem, wIndex) => {
                  return (_openBlock(), _createElementBlock("li", { key: wIndex }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(windIndex.value == wIndex?'active btn-content':'btn-content'),
                      onClick: ($event: any) => (handleSwitch('direction',wIndex))
                    }, [
                      _createElementVNode("span", null, _toDisplayString(windItem), 1)
                    ], 10, _hoisted_15)
                  ]))
                }), 128))
              ]),
              _cache[6] || (_cache[6] = _createElementVNode("p", { class: "option-title" }, "风速", -1)),
              _createElementVNode("ul", _hoisted_16, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(windSpeedList.value, (speedItem, spdIndex) => {
                  return (_openBlock(), _createElementBlock("li", { key: spdIndex }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(speedIndex.value == spdIndex?'active btn-content':'btn-content'),
                      onClick: ($event: any) => (handleSwitch('speed',spdIndex))
                    }, [
                      _createElementVNode("img", {
                        src: speedItem.icon,
                        alt: ""
                      }, null, 8, _hoisted_18),
                      _createElementVNode("span", null, _toDisplayString(speedItem.label), 1),
                      _createElementVNode("span", null, "(" + _toDisplayString(speedItem.value) + "m/s)", 1)
                    ], 10, _hoisted_17)
                  ]))
                }), 128))
              ])
            ])
          ]),
          footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_component_vkn_button, {
                label: "取消",
                type: "info",
                size: "medium",
                onClick: handleClose
              }),
              _createVNode(_component_vkn_button, {
                label: "确定",
                type: "primary",
                size: "medium",
                onClick: handleConfirm,
                loading: confirmLoading.value
              }, null, 8, ["loading"])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (showStandardSetting.value)
      ? (_openBlock(), _createBlock(_component_vkm_modal, {
          key: 1,
          class: "standard-setting-modal",
          title: "标准设置",
          onOnClose: handleCloseStandardSetting
        }, {
          content: _withCtx(() => [
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_20, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(scoringSettingItems, (item) => {
                return _createElementVNode("div", {
                  key: item.key,
                  class: "standard-setting-item"
                }, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("span", _hoisted_22, _toDisplayString(item.label), 1),
                    _createElementVNode("div", _hoisted_23, [
                      _createVNode(_component_el_slider, {
                        modelValue: scoringSetting[item.key],
                        "onUpdate:modelValue": ($event: any) => ((scoringSetting[item.key]) = $event),
                        class: "custom-controller-slider",
                        min: scoringSetting[item.minKey],
                        max: scoringSetting[item.maxKey],
                        step: 0.01,
                        "show-tooltip": false,
                        disabled: standardSettingLoading.value || scoringConfirmLoading.value
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "min", "max", "disabled"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createVNode(_component_el_input_number, {
                      modelValue: scoringSetting[item.key],
                      "onUpdate:modelValue": ($event: any) => ((scoringSetting[item.key]) = $event),
                      class: "custom-numner-input",
                      precision: 2,
                      min: scoringSetting[item.minKey],
                      max: scoringSetting[item.maxKey],
                      step: 0.01,
                      controls: false,
                      disabled: standardSettingLoading.value || scoringConfirmLoading.value
                    }, {
                      suffix: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(item.unit), 1)
                      ]),
                      _: 2
                    }, 1032, ["modelValue", "onUpdate:modelValue", "min", "max", "disabled"])
                  ])
                ])
              }), 64))
            ])), [
              [_directive_loading, standardSettingLoading.value]
            ])
          ]),
          footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_25, [
              _createVNode(_component_vkn_button, {
                label: "恢复默认",
                type: "info",
                size: "medium",
                disabled: standardSettingLoading.value || scoringConfirmLoading.value,
                onClick: handleRestoreScoringSetting
              }, null, 8, ["disabled"]),
              _createVNode(_component_vkn_button, {
                label: "确定",
                type: "primary",
                size: "medium",
                loading: scoringConfirmLoading.value,
                disabled: standardSettingLoading.value,
                onClick: handleSaveScoringSetting
              }, null, 8, ["loading", "disabled"])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})